import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, ShieldCheck, Gift } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="pricing" className="py-24 md:py-32 bg-brown-900 text-cream-50 relative overflow-hidden" data-id="element-140">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-141"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-142">
        <FadeIn data-id="element-143">
          <p className="text-xl md:text-2xl font-serif italic text-cream-100/80 max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-144">
            Mañana te vas a despertar, mirarte al espejo, y volver a sentir lo
            mismo:
          </p>
          <div className="max-w-xl mx-auto space-y-4 text-lg text-cream-200/60 mb-6" data-id="element-145">
            <p data-id="element-146">El frizz que no entiendes.</p>
            <p data-id="element-147">La frustración de no saber qué hacer.</p>
            <p data-id="element-148">La vergüenza de que tu pelo no refleje quién eres.</p>
          </div>
          <p className="text-2xl md:text-3xl font-serif text-white mb-4 leading-snug" data-id="element-149">
            Y vas a abrir otra vez el teléfono, buscar otro producto, gastar
            otro dinero…
          </p>
          <p className="text-3xl md:text-4xl font-serif font-medium text-terracotta italic mb-12" data-id="element-150">
            ¿O vas a hacer algo diferente hoy?
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-serif mb-10 text-cream-100" data-id="element-152">
            Deja de repetir el ciclo. <br data-id="element-153" />
            <span className="text-white font-bold" data-id="element-154">Empieza con tu mapa.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 max-w-2xl mx-auto" data-id="element-155">
          <div className="flex flex-col items-center" data-id="element-156">
            <p className="text-cream-200/50 text-sm mb-6 tracking-wide font-sans" data-id="element-157">
              EL DICCIONARIO DEL CABELLO — GUÍA COMPLETA 1A–4C
            </p>

            <div className="flex items-baseline gap-2 mb-2" data-id="element-158">
              <span className="text-6xl md:text-7xl font-serif font-bold text-white leading-none" data-id="element-159">
                $6<span className="text-4xl md:text-5xl" data-id="element-160">.99</span>
              </span>
              <span className="text-lg text-cream-200/60" data-id="element-161">USD</span>
            </div>

            <p className="text-cream-200/50 mb-10 text-sm" data-id="element-162">
              Pago único • Acceso de por vida
            </p>

            <a href="https://evolucionaactivo.com/cart/43902624759894:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full md:w-auto px-10 py-5 bg-terracotta hover:bg-terracotta-hover text-white text-xl font-bold rounded-full transition-all transform hover:scale-105 shadow-lg shadow-terracotta/30 flex items-center justify-center gap-3 mb-4 no-underline" data-id="element-163">
              Quiero dejar de adivinar
              <ArrowRight className="w-6 h-6" data-id="element-164" />
            </a>

            <p className="text-cream-200/40 text-xs mb-8" data-id="element-165">
              Recibes el PDF completo en tu correo en segundos
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-cream-200/60" data-id="element-166">
              <div className="flex items-center gap-1.5" data-id="element-167">
                <ShieldCheck className="w-4 h-4 text-olive-light" data-id="element-168" />
                <span data-id="element-169">Descarga segura e inmediata</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-170">
                <Gift className="w-4 h-4 text-olive-light" data-id="element-171" />
                <span data-id="element-172">Checklists + Plan 14 días incluidos</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.45} className="mt-14 max-w-xl mx-auto" data-id="element-173">
          <p className="text-cream-100 font-serif italic text-xl leading-relaxed" data-id="element-174">
            "Cada día que pasa sin un sistema, es otro día de prueba y error.
            Otro producto. Otra frustración."
          </p>
          <p className="text-cream-200/40 text-sm mt-8" data-id="element-175">
            Compatible con todos los dispositivos (Móvil, Tablet, PC).
          </p>
        </FadeIn>
      </div>
    </section>;
}